import EventEmitter from 'amkit3-modules/utils/stateful-events'
import UIEvent from 'amkit3-modules/v/ui/ui-event'

class Keyboard extends EventEmitter {
  constructor($, $container) {
    super()

    this.$ = $
    this.$container = $container

    this.$container.on('keydown', this.statefulDelegate(evt => {
      let $target = this.$(evt.srcElement || evt.target)
      let targetTagName = $target[0].tagName.toLowerCase()
      if (targetTagName != 'input' && targetTagName != 'textarea') {
        switch(evt.keyCode) {
          case 32:
            // space
            evt.preventDefault()
            evt.stopPropagation()
            break
          case 37:
            // lef arrow
            evt.preventDefault()
            evt.stopPropagation()
            this.emit(UIEvent.KEYBOARD_TIME_STEP_BACKWARD)
            break
          case 39:
            // right arrow
            evt.preventDefault()
            evt.stopPropagation()
            this.emit(UIEvent.KEYBOARD_TIME_STEP_FORWARD)
            break
          case 38:
            // up arrow
            evt.preventDefault()
            evt.stopPropagation()
            this.emit(UIEvent.KEYBOARD_VOLUME_UP)
            break
          case 40:
            // down arrow
            evt.preventDefault()
            evt.stopPropagation()
            this.emit(UIEvent.KEYBOARD_VOLUME_DOWN)
            break
        }
      }
    }))
    this.$container.on('keyup', this.statefulDelegate(evt => {
      let $target = this.$(evt.srcElement || evt.target)
      let targetTagName = $target[0].tagName.toLowerCase()
      if (targetTagName != 'input' && targetTagName != 'textarea') {
        switch(evt.keyCode) {
          case 32:
            // space
            this.emit(UIEvent.KEYBOARD_TOGGLE)
            break
          case 37:
            // left arrow
            this.emit(UIEvent.KEYBOARD_TIME_STEP_BACKWARD_DONE)
            break
          case 39:
            // right arrow
            this.emit(UIEvent.KEYBOARD_TIME_STEP_FORWARD_DONE)
            break
        }
      }
    }))
  }
}

export default Keyboard
